import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import ServiceSection from './components/ServiceSection';
import CaseSection from './components/CaseSection';
import StatsSection from './components/StatsSection';
import ProcessSection from './components/ProcessSection';
import PartnerSection from './components/PartnerSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <ServiceSection />
        <CaseSection />
        <StatsSection />
        <ProcessSection />
        <PartnerSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}